"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationDialog = exports.ConfirmationDialogPortal = void 0;
var confirmation_dialog_portal_component_1 = require("./confirmation-dialog-portal-component");
Object.defineProperty(exports, "ConfirmationDialogPortal", { enumerable: true, get: function () { return confirmation_dialog_portal_component_1.ConfirmationDialogPortal; } });
var confirmation_dialog_component_1 = require("./confirmation-dialog-component");
Object.defineProperty(exports, "ConfirmationDialog", { enumerable: true, get: function () { return confirmation_dialog_component_1.ConfirmationDialog; } });
//# sourceMappingURL=index.js.map